<template>
    <div class="testimony--wrapper">
        <div>
            <h1 class="heading heading--lg text-center" >MEET THE <span
                    class="underline--gradient__green">BOHEMIANS</span></h1>

            <testimony-slider :list="testimonies" class="sliders"></testimony-slider>
        </div>
    </div>

</template>

<script>
    import TestimonySlider from "../sliders/TestimonySlider";
    import testimonies from '../../assets/data/testimonies'

    export default {
        components: {TestimonySlider},
        name: "testimony",


        data() {
            return {
                testimonies
            }
        }

    }
</script>

<style scoped lang="scss" type="text/scss">
    @import "../../assets/scss/main";

    .heading {
        @media (min-width: $tablet) {
            font-size: 60px;
        }
    }

    .subtitle {
        margin-top: 45px;
        font-size: 18px;
        padding-left: 10px;
        padding-right: 10px;
    }

    .sliders {
        margin-top: 90px;
        padding-bottom: 95px;
    }

    .underline--gradient__green {
        background-image: linear-gradient(270deg, rgba(110, 58, 203, 0.9) 0%, rgba(0, 181, 242, 0.9) 100%);
        background-repeat: no-repeat;
        background-size: 100% 15px;
    }

    .testimony--wrapper {
        padding-top: 60px;
        height: auto;
        padding-bottom: 50px;
    }

    .testimony__paragraph {
        font-family: $font-header;
        max-width: 40%;
    }

    .heading {
        text-align: center;
    }

    .sub-header {
        text-align: center;
        margin-left: 35%;
        margin-top: 10%;
    }

    .offset-top {
        margin-top: -10%;
        height: auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/landingPageComponents/Testimony.vue